import { render } from "./APIRule.vue?vue&type=template&id=9adfe558"
import script from "./APIRule.vue?vue&type=script&lang=js"
export * from "./APIRule.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__